<div class="dialog-card">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-content">
      <div class="dialog-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
      </div>
      <h3 class="modal-title">Exit Confirmation</h3>
    </div>
    <button class="close-btn" (click)="onClose()" title="Close">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body">
    <p class="dialog-message">Are you sure you want to exit? Any unsaved changes will be lost.</p>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="onExitWithoutSaving()">Yes</button>
    <button class="btn btn-primary assignbtn" (click)="onSaveAndExit()">Save & Exit</button>
  </div>
</div>